import { useAuthorizedQuery, useAuthorizedMutation } from "..";
import { params } from "../../params";
import { InteractionType, InteractionInTrainingStatus } from "../../routes/simulator-live-mode/types";

export const useGetInteractionInTraining = (
  topicName: string,
  enabled: boolean
) => {
  return useAuthorizedQuery({
    queryKey: `useGetInteractionInTraining-${topicName}`,
    url: `${
      params.API_URL
    }/platform/interaction-in-training/topics/${encodeURIComponent(topicName)}`,
    enabled,
  });
};

export interface CreateInteractionInTrainingParams {
  interactionId: string;
  interactionType: InteractionType;
  status: InteractionInTrainingStatus;
  reason: string;
  topicId?: number;
  topicName?: string;
  name?: string;
}

export const useCreateInteractionInTraining = () => {
  return useAuthorizedMutation<any, CreateInteractionInTrainingParams>({
    url: `${params.API_URL}/platform/interaction-in-training/create`,
    method: "POST",
  });
};

export const useChangeStatusInteractionInTraining = () => {
  return useAuthorizedMutation({
    url: `${params.API_URL}/platform/interaction-in-training/status`,
    method: "PUT",
  });
};
